import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useMemberAuth } from '../../context/MemberAuthContext';
import { AuthLayout, inputCls } from '../../components/member/AuthLayout';

export default function MemberLogin() {
  const { login, isAuthenticated } = useMemberAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (isAuthenticated) return <Navigate to="/profilim" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await login(email, password);
      toast.success('Giriş başarılı');
      navigate('/profilim');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Giriş başarısız');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Üye Girişi" subtitle="Hesabınıza giriş yapın" testid="member-login-page"
      footer={<>Hesabınız yok mu? <Link to="/uye/kayit" className="text-[hsl(var(--gold))] font-medium hover:underline">Kayıt Ol</Link></>}>
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="member-login-form">
        <div>
          <label className="block text-sm font-medium mb-1.5">E-posta</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required data-testid="member-login-email" />
        </div>
        <div>
          <div className="flex items-center justify-between mb-1.5">
            <label className="block text-sm font-medium">Şifre</label>
            <Link to="/uye/sifremi-unuttum" className="text-xs text-[hsl(var(--gold))] hover:underline">Şifremi unuttum</Link>
          </div>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required data-testid="member-login-password" />
        </div>
        <button type="submit" disabled={isSubmitting}
          className="w-full px-4 py-2.5 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] font-medium text-sm hover:bg-[hsl(var(--gold)/0.92)] active:scale-[0.98] transition-colors duration-200 disabled:opacity-50"
          data-testid="member-login-submit">
          {isSubmitting ? 'Giriş yapılıyor...' : 'Giriş Yap'}
        </button>
      </form>
    </AuthLayout>
  );
}
